import { useTranslation } from 'react-i18next';

export const useBroadcastTranslation = () => useTranslation('broadcast');
